import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getNews } from '../Service/Api'
const News = () => {
  const [newsData, setNewsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getNews();
        setNewsData(data);
      } catch (error) {
        console.error("Failed to fetch news:", error);
        setNewsData([]); // Set to empty to ensure the empty state is handled
      }
    };
    fetchData();
  }, []);
  const emptyArray = [
    { title: "Stay Tuned For More Updates", description: "Stay Tuned For More Updates" },
    { title: "Stay Tuned For More Updates", description: "Stay Tuned For More Updates" },
    { title: "Stay Tuned For More Updates", description: "Stay Tuned For More Updates" }
  ];
  return (
    <>
      <div className="newsbg">
        <div className='d-flex'>

          <div className='title'>
            {/* <p>What’s new happening</p> */}
            <h2>Latest <span>News</span></h2>
          </div>

          <button className='button light'>
            <Link to="/News">
              <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/news-readmore.gif" className='img-fluid' alt="St francis school, Amritsar" />
              <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/news-read-more.png" className='img-fluid img-gif' alt="St francis school, Amritsar" />
            </Link>
          </button>

        </div>
        <marquee onMouseOver={(event) => event.currentTarget.stop()} direction="up" onMouseOut={(event) => event.currentTarget.start()}>
          <ul className="newsboxlist">
            {newsData.length > 0 ? newsData.map((item, index) => (
              <li key={index}>
                <div className="newsbox">
                  <div className="newsdesc">
                    <h6>{item.title}</h6>
                    <p>{item.description}</p>
                  </div>
                  <Link to={`https://webapi.entab.info/api/image/${item.attachments[0]}`} target="_blank"><i className="bi bi-paperclip"></i></Link>
                </div>
              </li>
            )) :
              emptyArray.map((data, index) => (
                <li key={index}>
                  <div className="newsbox">
                    <div className="newsdesc">
                      <h6>{data.title}</h6>
                      <p>{data.description}</p>
                    </div>
                    <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
                  </div>
                </li>
              ))
            }
            {/* <li key={index}>
                <div className="newsbox">
                  <div className="newsdesc">
                  <h6>{data.title}</h6>
                  <p>{data.description}</p>
                  </div>
                  <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
                </div>
              </li> */}
            {/* <li>
                <div className="newsbox">
                  <div className="newsdesc">
                  <h6>Online Registration</h6>
                  <p>Online Registraiton 2025-26</p>
                  </div>
                  <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
                </div>
              </li>
              <li>
                <div className="newsbox">
                  <div className="newsdesc">
                  <h6>Online Registration</h6>
                  <p>School uniform (Kindergarten), Kindly go through the attachment</p>
                  </div>
                  <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
                </div>
              </li>
              <li>
                <div className="newsbox">
                  <div className="newsdesc">
                  <h6>Online Registration</h6>
                  <p>School uniform (Kindergarten), Kindly go through the attachment</p>
                  </div>
                  <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
                </div>
              </li> */}
          </ul>
        </marquee>
      </div>
    </>
  )
}

export default News
